import React, { useState } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import FormTextField from 'components/formComponents/FormTextField';
import { FormCheckboxField } from 'components/formComponents/FormCheckBoxField';
import { Link, useNavigate } from '@reach/router';
import { AppPath } from 'appConstants';
import { useDispatch, useSelector } from 'react-redux';
import {
  signIn,
  SignInAttempt,
  selectAuthMessage,
  selectAuthStatus,
  autoSignIn,
} from 'reducers/auth';
import { Spinner } from 'components/spinner/Spinner';

const SignInForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const message = useSelector(selectAuthMessage);
  const authStatus = useSelector(selectAuthStatus);

  const [submitError, setSubmitError] = useState('');
  const initialValues: SignInAttempt = {
    emailAddress: '',
    password: '',
    rememberMe: false,
  };
  const validationSchema = Yup.object({
    emailAddress: Yup.string()
      .required('An email address is required')
      .email('Must be a valid email address'),
    password: Yup.string().required('You must provide a password'),
    rememberMe: Yup.boolean(),
  });

  const getURLToken = new URLSearchParams(window.location.search).get('token');
  const authQuery = new URLSearchParams(window.location.search).get('auth');

  if (authQuery === 'sign-out') navigate(AppPath.SIGN_IN);

  const handleSubmitForm = (
    payload: SignInAttempt,
    setSubmitting: any,
    resetForm: any
  ) => {
    setSubmitError('');
    dispatch(signIn(payload));
  };

  if (getURLToken) {
    dispatch(autoSignIn({ token: encodeURIComponent(getURLToken) }));

    if (message) {
      navigate(AppPath.SIGN_IN);
    }
    return (
      <div className="PageSpinner">
        <Spinner />
      </div>
    );
  }
  return (
    <div className="Form">
      <Formik
        initialValues={initialValues}
        onSubmit={(values: any, { setSubmitting, resetForm }: any) => {
          handleSubmitForm(values, setSubmitting, resetForm);
        }}
        validationSchema={validationSchema}
      >
        {({ isSubmitting }) => (
          <Form>
            <h1>Sign in</h1>
            <p className="SubTitle">Enter your details below</p>
            {message && <p className="SignInErrorMessage">{message}</p>}
            <div className="UserCredentialsSection">
              <FormTextField
                field={'emailAddress'}
                label={'Email address'}
                required={true}
              />
              <FormTextField
                field={'password'}
                label={'Password'}
                type={'password'}
                required={true}
              />
            </div>
            <div className="RememberMeSection">
              <FormCheckboxField field={'rememberMe'} label={'Remember me'} />
              <Link to={AppPath.FORGOTTEN_PASSWORD}>
                <p>Forgotten password?</p>
              </Link>
            </div>
            {submitError && <div className="GeneralError">{submitError}</div>}
            <button
              className="Btn BtnOrange"
              type="submit"
              disabled={authStatus === 'pending'}
            >
              {authStatus === 'pending' ? (
                <Spinner color="#ffffff" />
              ) : (
                'Sign In'
              )}
            </button>
            <div className="Redirect">
              No account?{' '}
              <Link to={AppPath.SUBSCRIBE}>
                <p>Subscribe</p>
              </Link>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default SignInForm;
